<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Detalle del Trámite:{{ tipotramite.codigo }} - {{ tipotramite.tipo }}</h5>
          <div class="row mb-3">
            <table>
              <tr>
                <th>Costo DDE:</th>
                <td>{{ tipotramite.costo }}</td>
                <th>Unidad:</th>
                <td>{{ tipotramite.codigo_unidad }} - {{ tipotramite.nombre_unidad }}</td>
              </tr>
              <tr>
                <th>Costo Minedu:</th>
                <td>{{ tipotramite.costo_minedu }}</td>
                <th>Seccion:</th>
                <td>{{ tipotramite.codigo_area }} - {{ tipotramite.nombre_area }}</td>
              </tr>
              <tr>
                <th>Tiempo:</th>
                <td>{{ tipotramite.tiempo }} : {{ tipotramite.unidad_tiempo }}</td>
                <th>Estado:</th>
                <td>
                  <BBadge :variant="tipotramite.estado === 'Activo' ? 'success' : 'danger'">
                  {{ tipotramite.estado }}
                  </BBadge>
                </td>
              </tr>
            </table>
          </div>
        </div>
        
        <div class="card-body">
          <div class="row">
            <div class="col-md-7">
            <div class="card">
              <div class="card-header" style="margin: 0px; padding-bottom: 0px;">
                <label style="float: left;"><h5>Requisitos</h5></label>
                <BButton
                    v-if="hasPermission('tipotramite_create')"
                    @click="showRequisitoModal(null)"
                    variant="primary"
                    class="btn-round btn-sm me-2 mb-3"
                    style="float: right;"
                  >
                    <i class="fa fa-plus me-1"></i> Nuevo Requisito
                </BButton>  
              </div>
              <div class="card-body"  style="margin-top: -25px;">
                <div class="mt-3">
                  <div class="table-responsive">
                    <table class="table table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                      <thead>
                        <tr style="line-height: 8px;">
                          <th>Descripción</th>
                          <th>Estado</th>
                          <th>Accion</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="requisito in requisitos" :key="requisito.id">
                          <td>{{ requisito.descripcion }}</td>
                          <td>
                            <BBadge :variant="requisito.estado === 'Activo' ? 'success' : 'danger'">
                              {{ requisito.estado }}
                            </BBadge>
                          </td>
                          <td>
                            <div class="btn-group">
                              <BButton
                                v-if="hasPermission('tipotramite_update')"
                                @click="showRequisitoModal(requisito)"
                                variant="warning"
                                size="sm"
                                class="me-1"
                              >
                                <i class="fa fa-edit"></i>
                              </BButton>
                              <BButton
                                v-if="hasPermission('tipotramite_delete')"
                                @click="confirmDeleteRequisito(requisito)"
                                variant="danger"
                                size="sm"
                              >
                                <i class="fa fa-trash"></i>
                              </BButton>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div class="col-md-5">
              <div class="card">
                <div class="card-header" style="margin: 0px; padding-bottom: 0px;">
                  <label style="float: left;"><h5>Valorados</h5></label>
                  <BButton
                    v-if="hasPermission('tipotramite_create')"
                    @click="showValoradoModal(null)"
                    variant="primary"
                    class="btn-round btn-sm me-2 mb-3"
                    style="float: right;"
                  >
                    <i class="fa fa-plus me-1"></i> Nuevo Valorado
                  </BButton>
                </div>
                <div class="card-body" style="margin-top: -25px;">
                  <div class="mt-3">
                  <div class="table-responsive" style="margin: 0px; padding: 0px;">
                    <table class="table table-sm table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                      <thead class="text-primary">
                        <tr style="line-height: 8px;">
                          <th>Valorado</th>
                          <th>Costo</th>
                          <th>Estado</th>
                          <th>Accion</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="valorado in valorados" :key="valorado.id">
                          <td>{{ valorado.descripcion }}</td>
                          <td>{{ valorado.costo }}</td>
                          <td>
                            <BBadge :variant="valorado.estado === 'Activo' ? 'success' : 'danger'">
                              {{ valorado.estado }}
                            </BBadge>
                          </td>
                          <td>
                            <div class="btn-group">
                              <BButton
                                v-if="hasPermission('tipotramite_update')"
                                @click="showValoradoModal(valorado)"
                                variant="warning"
                                size="sm"
                                class="me-1"
                              >
                                <i class="fa fa-edit"></i>
                              </BButton>
                              <BButton
                                v-if="hasPermission('tipotramite_delete')"
                                @click="confirmDeleteValorado(valorado)"
                                variant="danger"
                                size="sm"
                              >
                                <i class="fa fa-trash"></i>
                              </BButton>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal para Requisitos -->
    <BModal
      v-model="requisitoModalVisible"
      :title="requisitoModalTitle"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleRequisitoSubmit">
        <div class="form-group">
          <label class="form-label">Descripción</label>
          <textarea
            v-model="requisitoForm.descripcion"
            class="form-control"
            :class="{ 'is-invalid': requisitoErrors.descripcion }"
            rows="3"
            required
          ></textarea>
          <div class="invalid-feedback" v-if="requisitoErrors.descripcion">
            {{ requisitoErrors.descripcion[0] }}
          </div>
        </div>
        
        <div class="form-group mt-3">
          <label class="form-label">Estado</label>
          <select
            v-model="requisitoForm.estado"
            class="form-select"
            :class="{ 'is-invalid': requisitoErrors.estado }"
            required
          >
            <option value="activo">Activo</option>
            <option value="inactivo">Inactivo</option>
          </select>
          <div class="invalid-feedback" v-if="requisitoErrors.estado">
            {{ requisitoErrors.estado[0] }}
          </div>
        </div>
        
        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="requisitoModalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingRequisitoForm"
          >
            <span v-if="loadingRequisitoForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditingRequisito ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
    
    <!-- Modal para Valorados -->
    <BModal
      v-model="valoradoModalVisible"
      :title="valoradoModalTitle"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <form @submit.prevent="handleValoradoSubmit">
        <div class="form-group">
          <label class="form-label">Valorado</label>
          <select
            v-model="valoradoForm.id_valorado"
            class="form-select"
            :class="{ 'is-invalid': valoradoErrors.id_valorado }"
            required
            :disabled="loadingValoradosList"
          >
            <option value="">Seleccione un valorado</option>
            <option 
              v-for="valorado in valoradosList" 
              :key="valorado.id" 
              :value="valorado.id"
            >
              {{ valorado.descripcion }}
            </option>
          </select>
          <div class="invalid-feedback" v-if="valoradoErrors.id_valorado">
            {{ valoradoErrors.id_valorado[0] }}
          </div>
          <div v-if="loadingValoradosList" class="text-muted small">
            Cargando lista de valorados...
          </div>
        </div>
        
        <div class="form-group mt-3">
          <label class="form-label">Estado</label>
          <select
            v-model="valoradoForm.estado"
            class="form-select"
            :class="{ 'is-invalid': valoradoErrors.estado }"
            required
          >
            <option value="Activo">Activo</option>
            <option value="Inactivo">Inactivo</option>
          </select>
          <div class="invalid-feedback" v-if="valoradoErrors.estado">
            {{ valoradoErrors.estado[0] }}
          </div>
        </div>
        
        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="valoradoModalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingValoradoForm"
          >
            <span v-if="loadingValoradoForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ isEditingValorado ? 'Actualizar' : 'Guardar' }}
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import { useAuthStore } from '../../stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BBadge } from 'bootstrap-vue-3';

interface Requisito {
  id: number;
  id_tipotramite: number;
  descripcion: string;
  estado: string;
}

interface Valorado {
  id: number;
  id_tipotramite: number;
  id_valorado: number;
  estado: string;
}

interface ValoradoItem {
  id: number;
  nombre: string;
  costo: number;
}

export default {
  components: {
    BModal,
    BButton,
    BBadge
  },
  setup() {
    const route = useRoute();
    const authStore = useAuthStore();
    
    // Datos del trámite
    const tipotramite = ref<any>({});
    const loading = ref(true);
    
    // Requisitos
    const requisitos = ref<Requisito[]>([]);
    const loadingRequisitos = ref(false);
    
    // Valorados
    const valorados = ref<Valorado[]>([]);
    const valoradosList = ref<ValoradoItem[]>([]);
    const loadingValorados = ref(false);
    const loadingValoradosList = ref(false);
    
    // Modal de Requisitos
    const requisitoModalVisible = ref(false);
    const isEditingRequisito = ref(false);
    const loadingRequisitoForm = ref(false);
    const requisitoErrors = ref<Record<string, string[]>>({});
    
    const requisitoForm = ref({
      id: null as number | null,
      id_tipotramite: route.params.id,
      descripcion: '',
      estado: 'activo'
    });
    
    // Modal de Valorados
    const valoradoModalVisible = ref(false);
    const isEditingValorado = ref(false);
    const loadingValoradoForm = ref(false);
    const valoradoErrors = ref<Record<string, string[]>>({});
    
    const valoradoForm = ref({
      id: null as number | null,
      id_tipotramite: route.params.id,
      id_valorado: '',
      estado: 'activo'
    });
    
    const requisitoModalTitle = computed(() => {
      return isEditingRequisito.value ? 'Editar Requisito' : 'Nuevo Requisito';
    });
    
    const valoradoModalTitle = computed(() => {
      return isEditingValorado.value ? 'Editar Valorado' : 'Nuevo Valorado';
    });
    
    const fetchTipotramite = async () => {
      try {
        const response = await axios.get(`/tipotramite/edit/${route.params.id}`);
        tipotramite.value = response.data.tipotramite;
      } catch (error) {
        console.error('Error al cargar el trámite:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la información del trámite'
        });
      } finally {
        loading.value = false;
      }
    };
    
    const fetchRequisitos = async () => {
      loadingRequisitos.value = true;
      try {
        const response = await axios.get(`/tipotramiterequisito/list/${route.params.id}`);
        requisitos.value = response.data.requisitos;
      } catch (error) {
        console.error('Error al cargar requisitos:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los requisitos'
        });
      } finally {
        loadingRequisitos.value = false;
      }
    };
    
    const fetchValorados = async () => {
      loadingValorados.value = true;
      try {
        const response = await axios.get(`/tipotramitevalorado/list/${route.params.id}`);
        valorados.value = response.data.valorados;
      } catch (error) {
        console.error('Error al cargar valorados:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los valorados'
        });
      } finally {
        loadingValorados.value = false;
      }
    };
    
    const fetchValoradosList = async () => {
      loadingValoradosList.value = true;
      try {
        const response = await axios.get('/valorado/select');
        valoradosList.value = response.data.valorados;
      } catch (error) {
        console.error('Error al cargar lista de valorados:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo cargar la lista de valorados disponibles'
        });
      } finally {
        loadingValoradosList.value = false;
      }
    };
    
    const showRequisitoModal = (requisito: Requisito | null) => {
      requisitoErrors.value = {};
      if (requisito) {
        isEditingRequisito.value = true;
        requisitoForm.value = {
          id: requisito.id,
          id_tipotramite: requisito.id_tipotramite,
          descripcion: requisito.descripcion,
          estado: requisito.estado
        };
      } else {
        isEditingRequisito.value = false;
        requisitoForm.value = {
          id: null,
          id_tipotramite: route.params.id,
          descripcion: '',
          estado: 'activo'
        };
      }
      requisitoModalVisible.value = true;
    };
    
    const showValoradoModal = (valorado: Valorado | null) => {
      valoradoErrors.value = {};
      if (valorado) {
        isEditingValorado.value = true;
        valoradoForm.value = {
          id: valorado.id,
          id_tipotramite: valorado.id_tipotramite,
          id_valorado: valorado.id_valorado,
          estado: valorado.estado
        };
      } else {
        isEditingValorado.value = false;
        valoradoForm.value = {
          id: null,
          id_tipotramite: route.params.id,
          id_valorado: '',
          estado: 'activo'
        };
      }
      valoradoModalVisible.value = true;
    };
    
    const handleRequisitoSubmit = async () => {
      loadingRequisitoForm.value = true;
      requisitoErrors.value = {};
      
      try {
        let response;
        
        if (isEditingRequisito.value && requisitoForm.value.id) {
          response = await axios.post(`/tipotramiterequisito/update/${requisitoForm.value.id}`, requisitoForm.value);
        } else {
          response = await axios.post('/tipotramiterequisito/create', requisitoForm.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        requisitoModalVisible.value = false;
        fetchRequisitos();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          requisitoErrors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingRequisitoForm.value = false;
      }
    };
    
    const handleValoradoSubmit = async () => {
      loadingValoradoForm.value = true;
      valoradoErrors.value = {};
      
      try {
        let response;
        
        if (isEditingValorado.value && valoradoForm.value.id) {
          response = await axios.post(`/tipotramitevalorado/update/${valoradoForm.value.id}`, valoradoForm.value);
        } else {
          response = await axios.post('/tipotramitevalorado/create', valoradoForm.value);
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: response.data.message
        });
        
        valoradoModalVisible.value = false;
        fetchValorados();
      } catch (error: any) {
        if (error.response && error.response.status === 422) {
          valoradoErrors.value = error.response.data.errors;
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.response?.data?.message || 'Ocurrió un error al procesar la solicitud'
          });
        }
      } finally {
        loadingValoradoForm.value = false;
      }
    };
    
    const confirmDeleteRequisito = (requisito: Requisito) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar este requisito?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteRequisito(requisito.id);
        }
      });
    };
    
    const deleteRequisito = async (id: number) => {
      try {
        await axios.get(`/tipotramiterequisito/delete/${id}`);
        Swal.fire({
          icon: 'success',
          title: 'Requisito eliminado',
          text: 'El requisito ha sido eliminado correctamente'
        });
        await fetchRequisitos();
      } catch (error: any) {
        console.error('Error al eliminar requisito:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar el requisito'
        });
      }
    };
    
    const confirmDeleteValorado = (valorado: Valorado) => {
      Swal.fire({
        title: '¿Está seguro?',
        text: `¿Desea eliminar este valorado?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          deleteValorado(valorado.id);
        }
      });
    };
    
    const deleteValorado = async (id: number) => {
      try {
        await axios.get(`/tipotramitevalorado/delete/${id}`);
        Swal.fire({
          icon: 'success',
          title: 'Valorado eliminado',
          text: 'El valorado ha sido eliminado correctamente'
        });
        await fetchValorados();
      } catch (error: any) {
        console.error('Error al eliminar valorado:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'No se pudo eliminar el valorado'
        });
      }
    };
    
    const getValoradoName = (id: number) => {
      const valorado = valoradosList.value.find(v => v.id === id);
      return valorado ? valorado.nombre : 'Desconocido';
    };
    
    const hasPermission = (permission: string) => {
      return authStore.hasPermission(permission);
    };
    
    onMounted(() => {
      fetchTipotramite();
      fetchRequisitos();
      fetchValorados();
      fetchValoradosList();
    });
    
    return {
      tipotramite,
      loading,
      requisitos,
      valorados,
      valoradosList,
      requisitoModalVisible,
      isEditingRequisito,
      requisitoForm,
      requisitoErrors,
      loadingRequisitoForm,
      valoradoModalVisible,
      isEditingValorado,
      valoradoForm,
      valoradoErrors,
      loadingValoradoForm,
      loadingValoradosList,
      requisitoModalTitle,
      valoradoModalTitle,
      showRequisitoModal,
      showValoradoModal,
      handleRequisitoSubmit,
      handleValoradoSubmit,
      confirmDeleteRequisito,
      confirmDeleteValorado,
      getValoradoName,
      hasPermission
    };
  }
};
</script>

<style scoped>
  .nav-tabs .nav-link.active {
    background-color: #FFF8F0;
    border-color: #dee2e6 #dee2e6 #fff;
  }
  
  .form-control-plaintext {
    padding: 0.375rem 0;
    margin-bottom: 0;
    background-color: transparent;
    border: solid transparent;
    border-width: 1px 0;
  }
  
  .btn-round {
    border-radius: 50px;
  }
  
  .badge {
    font-size: 0.85em;
    padding: 0.2em 0.4em;
  }
  thead th {
    background-color: #D84315;
    color:#ffffff;
    position: sticky;
    top: 0;
  }
</style>